import PropTypes from 'prop-types';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
var PROMISE_NAME = 'data';
var MANIPULATION_NAME = 'manipulation';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var PromisePropTypes = PropTypes.shape({
  data: PropTypes.any,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.instanceOf(Error)]),
  refetch: PropTypes.func.isRequired
});
var ConfigPropTypes = {
  name: PropTypes.string,
  defaultData: PropTypes.any,
  promise: PropTypes.func.isRequired,
  skip: PropTypes.func,
  variables: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  loading: PropTypes.func,
  error: PropTypes.func,
  complete: PropTypes.func
};
var ManipulationPropTypes = PropTypes.shape({
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.instanceOf(Error)])
});

var manipulationPropTypes = function manipulationPropTypes() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var baseConfig = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.instanceOf(Error)])
  };

  var shape = _extends({}, baseConfig);

  args.forEach(function (name) {
    shape[name] = PropTypes.shape(_extends({}, baseConfig, {
      manipulate: PropTypes.func.isRequired
    })).isRequired;
  });
  return PropTypes.shape(shape);
};

var ConfigManipulationPropTypes = {
  name: PropTypes.string,
  promises: PropTypes.object,
  loading: PropTypes.func,
  error: PropTypes.func
};
/* eslint-disable no-restricted-syntax */

var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }

  return false;
};

var isFunction = function isFunction(fn) {
  return fn && {}.toString.call(fn) === '[object Function]';
};

var isObject = function isObject(ob) {
  return ob && {}.toString.call(ob) === '[object Object]';
};

var reservedProps = ["name", "defaultData", "skip", "promise", "loading", "error", "complete", "variables", "children"];

var excludeReservedProps = function excludeReservedProps(props) {
  var newProps = {};

  for (var prop in props) {
    if (!reservedProps.includes(prop)) {
      newProps[prop] = props[prop];
    }
  }

  return newProps;
};

var getVariables = function getVariables(_ref) {
  var variables = _ref.variables,
      props = objectWithoutProperties(_ref, ['variables']);
  var newProps = null;

  if (isFunction(variables)) {
    newProps = variables(excludeReservedProps(props));
  } else if (isObject(variables)) {
    newProps = variables;
  }

  return newProps;
};

var getDefaultData = function getDefaultData(_ref2) {
  var defaultData = _ref2.defaultData,
      props = objectWithoutProperties(_ref2, ['defaultData']);

  if (isFunction(defaultData)) {
    return defaultData(excludeReservedProps(props));
  }

  return defaultData || null;
};

var PromiseSwitch = function PromiseSwitch() {
  var _this = this;

  classCallCheck(this, PromiseSwitch);

  this.generateKey = function () {
    return Date.now();
  };

  this.call = function (promise) {
    _this.lastPromiseKey = _this.generateKey();
    var key = _this.lastPromiseKey;
    return new Promise(function (resolve, reject) {
      promise.then(function (data) {
        if (key === _this.lastPromiseKey) {
          resolve(data);
        }
      }).catch(function (error) {
        if (key === _this.lastPromiseKey) {
          reject(error);
        }
      });
    });
  };

  this.cancel = function () {
    _this.lastPromiseKey = _this.generateKey();
  };

  this.lastPromiseKey = this.generateKey();
};

var PromiseWrapper = function (_React$PureComponent) {
  inherits(PromiseWrapper, _React$PureComponent);

  function PromiseWrapper(props) {
    classCallCheck(this, PromiseWrapper);

    var _this = possibleConstructorReturn(this, (PromiseWrapper.__proto__ || Object.getPrototypeOf(PromiseWrapper)).call(this, props));

    _initialiseProps.call(_this);

    var skip = props.skip;
    _this.skip = skip(props);
    _this.state = {
      loading: !_this.skip,
      error: null,
      data: getDefaultData(props)
    };
    _this.loaded = false;
    _this.isMount = false;
    _this.promiseSwitch = new PromiseSwitch();
    return _this;
  }

  createClass(PromiseWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMount = true;

      if (!this.skip) {
        this.query();
        this.loaded = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          skip = _props.skip,
          variables = _props.variables;

      if (!this.loaded && !skip(this.props)) {
        this.skip = false;
        this.loaded = true;
        this.refetch();
      } else if (!this.skip && variables && shallowDiffers(getVariables(prevProps), getVariables(this.props))) {
        this.refetch();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMount = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          promiseLoading = _state.loading,
          promiseError = _state.error;
      var _props2 = this.props,
          name = _props2.name,
          loading = _props2.loading,
          error = _props2.error,
          children = _props2.children;

      var props = _extends({}, excludeReservedProps(this.props), getVariables(this.props), defineProperty({}, name, _extends({}, this.state, {
        refetch: this.refetch
      })));

      if (promiseLoading && loading) {
        return loading(props);
      }

      if (promiseError && error) {
        return error(props);
      }

      if (children) {
        return children(props);
      }

      return null;
    }
  }]);
  return PromiseWrapper;
}(React.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.query = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _props3 = _this2.props,
        promise = _props3.promise,
        complete = _props3.complete;

    var props = _extends({}, excludeReservedProps(_this2.props), getVariables(_this2.props));

    _this2.promiseSwitch.call(Promise.resolve(promise.apply(undefined, [props].concat(args)))).then(function (data) {
      var response = complete(data);

      if (_this2.isMount) {
        _this2.setState({
          loading: false,
          data: response,
          error: null
        });
      }

      return response;
    }).catch(function (error) {
      if (_this2.isMount) {
        _this2.setState({
          loading: false,
          error: error
        });
      }
    });
  };

  this.refetch = function () {
    var loading = _this2.state.loading;

    if (!loading) {
      _this2.setState({
        loading: true
      });
    }

    return _this2.query.apply(_this2, arguments);
  };
};

PromiseWrapper.propTypes = ConfigPropTypes;
PromiseWrapper.defaultProps = {
  skip: function skip() {
    return false;
  },
  complete: function complete(data) {
    return data;
  },
  name: PROMISE_NAME,
  defaultData: null,
  variables: null,
  loading: null,
  error: null
};

var createPromise = function createPromise() {
  var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var component = function component(config) {
    return React.createElement(PromiseWrapper, _extends({}, defaultConfig, config));
  };

  var hoc = function hoc() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (Component) {
      var comp = function comp(props) {
        return React.createElement(PromiseWrapper, _extends({}, props, defaultConfig, config), function (cProps) {
          return React.createElement(Component, cProps);
        });
      };

      comp.displayName = "hoc(PromiseWrapper)";
      return comp;
    };
  };

  return {
    hoc: hoc,
    component: component
  };
};

var _createPromise = createPromise(),
    query = _createPromise.hoc,
    Query = _createPromise.component;

var ManipulationWrapper = function (_React$PureComponent) {
  inherits(ManipulationWrapper, _React$PureComponent);

  function ManipulationWrapper(props) {
    classCallCheck(this, ManipulationWrapper);

    var _this = possibleConstructorReturn(this, (ManipulationWrapper.__proto__ || Object.getPrototypeOf(ManipulationWrapper)).call(this, props));

    _this.manipulate = function (name, promise) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var switcher = _this.switchers[name];
        var item = _this.state[name];

        if (!item.loading) {
          _this.setState(defineProperty({}, name, _extends({}, item, {
            loading: true
          })));
        }

        return switcher.call(Promise.resolve(promise.apply(undefined, [_this.props].concat(args)))).then(function (data) {
          if (_this.isMount) {
            _this.setState(defineProperty({}, name, _extends({}, item, {
              loading: false,
              error: null,
              data: data
            })));
          }

          return data;
        }).catch(function (error) {
          if (_this.isMount) {
            _this.setState(defineProperty({}, name, _extends({}, item, {
              loading: false,
              error: error
            })));
          }

          throw error;
        });
      };
    };

    var _props$promises = props.promises,
        promises = _props$promises === undefined ? {} : _props$promises;
    _this.isMount = false;
    _this.state = {};
    _this.switchers = {};
    Object.keys(promises).forEach(function (promiseName) {
      var promise = promises[promiseName];
      _this.state[promiseName] = {
        loading: false,
        error: null,
        data: null,
        manipulate: _this.manipulate(promiseName, promise)
      };
      _this.switchers[promiseName] = new PromiseSwitch();
    });
    return _this;
  }

  createClass(ManipulationWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isMount = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isMount = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$name = _props.name,
          name = _props$name === undefined ? MANIPULATION_NAME : _props$name,
          promises = _props.promises,
          loadingFunc = _props.loading,
          errorFunc = _props.error,
          children = _props.children,
          other = objectWithoutProperties(_props, ['name', 'promises', 'loading', 'error', 'children']);
      var states = Object.values(this.state);
      var loading = states.some(function (item) {
        return item.loading;
      });
      var errorItem = states.find(function (item) {
        return item.error;
      });

      var props = _extends(defineProperty({}, name, _extends({}, this.state, {
        loading: loading,
        error: errorItem ? errorItem.error : null
      })), other);

      if (loadingFunc && loading) {
        return loadingFunc(props);
      }

      if (errorFunc && errorItem) {
        return errorFunc(props);
      }

      if (children) {
        return children(props);
      }

      return null;
    }
  }]);
  return ManipulationWrapper;
}(React.PureComponent);

ManipulationWrapper.propTypes = _extends({}, ConfigManipulationPropTypes);

var createManipulationPromise = function createManipulationPromise() {
  var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var component = function component(config) {
    return React.createElement(ManipulationWrapper, _extends({}, defaultConfig, config));
  };

  var hoc = function hoc() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (Component) {
      var comp = function comp(props) {
        return React.createElement(ManipulationWrapper, _extends({}, props, defaultConfig, config), function (cProps) {
          return React.createElement(Component, cProps);
        });
      };

      comp.displayName = 'hoc(ManipulationWrapper)';
      return comp;
    };
  };

  return {
    hoc: hoc,
    component: component
  };
};

var _createManipulationPr = createManipulationPromise(),
    manipulation = _createManipulationPr.hoc,
    Manipulation = _createManipulationPr.component;

var compose = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  }, function (arg) {
    return arg;
  });
};
/**
 * Query configuration.
 * @typedef {Object} QueryConfig
 * @property {boolean} [skip=false] - The name of the employee.
 * @property {*} [variables=null] - The value, it will refetch the promise
 * if it's not equal with previous value.
 * @property {*} [defaultData=null] -The start data for the state.
 */

/**
 * State object.
 * @typedef {Object} State
 * @property {boolean} loading - Loading for promise.
 * @property {*} data - Current data for promise.
 * @property {Object} [error=null] -The error object.
 */

/**
 * Loading hook to get loading status for all states.
 * @param {State[]} states - The states.
 * @returns {boolean} Loading status (true or false)
 */


var useLoadingForStates = function useLoadingForStates() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  var loading = useMemo(function () {
    return states.some(function (s) {
      return s.loading;
    });
  }, states);
  return loading;
};

var usePromise = function usePromise(promise, updateState, variables) {
  var forQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var promiseSwitch = useMemo(function () {
    return new PromiseSwitch();
  }, []);
  var action = useCallback(function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    updateState(function (prev) {
      if (prev.loading) {
        return prev;
      }

      return _extends({}, prev, {
        loading: true
      });
    });
    var allArgs = [].concat(args);

    if (forQuery) {
      allArgs.unshift(variables);
    }

    return promiseSwitch.call(promise.apply(undefined, toConsumableArray(allArgs))).then(function (response) {
      updateState(function (prev) {
        return _extends({}, prev, {
          loading: false,
          data: response,
          error: null
        });
      });
      return response;
    }).catch(function (error) {
      updateState(function (prev) {
        return _extends({}, prev, {
          loading: false,
          error: error
        });
      });
      throw error;
    });
  }, [updateState, promiseSwitch, variables]);
  return [action, promiseSwitch];
};
/**
 * Manipulation hook to update data.
 * @param {Promise} promise - The promise.
 * @returns {Array} Array with current state and a manipulate function
 */


var useManipulate = function useManipulate(promise) {
  var _useState = useState({
    loading: false,
    error: null,
    data: null
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      updateState = _useState2[1];

  var _usePromise = usePromise(promise, updateState),
      _usePromise2 = slicedToArray(_usePromise, 2),
      action = _usePromise2[0],
      subscriber = _usePromise2[1];

  useEffect(function () {
    return function cleanup() {
      subscriber.cancel();
    };
  }, []);
  return [state, action];
};
/**
 * Query hook to fetch data from promise.
 * @param {Promise} promise - The promise.
 * @param {QueryConfig} [config={}] - The config to initialize the state.
 * @returns {Array} Array with current state and a refetch function
 */


var useQuery = function useQuery(promise) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mergedConfig = useMemo(function () {
    return _extends({}, useQuery.config, config);
  }, []);

  var _useState3 = useState({
    loading: !mergedConfig.skip,
    error: null,
    data: mergedConfig.defaultData
  }),
      _useState4 = slicedToArray(_useState3, 2),
      state = _useState4[0],
      updateState = _useState4[1];

  var _usePromise3 = usePromise(promise, updateState, config.variables, true),
      _usePromise4 = slicedToArray(_usePromise3, 2),
      refetch = _usePromise4[0],
      subscriber = _usePromise4[1];

  useEffect(function () {
    !mergedConfig.skip && refetch().catch(function (error) {
      return window.console && console.error(error);
    });
    return function cleanup() {
      subscriber.cancel();
    };
  }, [config.variables, refetch]);
  return [state, refetch];
};
/**
 * @constant
 * @type {QueryConfig}
 * @default
 */


var defaultConfig = {
  skip: false,
  defaultData: null,
  variables: null
};
Object.defineProperty(useQuery, 'config', {
  configurable: true,
  get: function get$$1() {
    return defaultConfig;
  }
});
/**
 * Update global Query config.
 * @param {QueryConfig} [config={}] - The config to update.
 * @returns {QueryConfig} Updated config
 */

useQuery.updateConfig = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.assign(defaultConfig, config);
  return defaultConfig;
};

export { query, Query, createPromise, manipulation, Manipulation, createManipulationPromise, PromisePropTypes, ManipulationPropTypes, manipulationPropTypes, compose, useQuery, useManipulate, useLoadingForStates };